import React from "react";
import PropTypes from "prop-types";
import { Flex, Button, Modal, Box, Text, List, Spinner } from "samba-ui";
import useTopChannels from "./hooks/useTopChannels";

const TopChannelsModal = ({ country, isOpen, onClose }) => {
  const { loading, topChannels } = useTopChannels();
  const _topChannels = topChannels.filter(t => t.country === country);
  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} width={800}>
      <Modal.Header borderColor="#d6d6d6 !important">
        <Text>Top Channels</Text>
      </Modal.Header>
      <Modal.Content
        minHeight={350}
        maxHeight={"calc(100vh - 200px)"}
        overflow="scroll"
      >
        {loading ? (
          <Flex alignItems="center" justifyContent="center">
            <Spinner variant="large" />
          </Flex>
        ) : (
          <Box>
            <List.Header borderColor="#d6d6d6 !important">
              <Flex justifyContent="space-between" alignItems="center">
                <Box width={1 / 3}>SSID</Box>
                <Box width={1 / 3}>Network Call Sign</Box>
                <Box width={1 / 3}>SambaTV Call Sign</Box>
              </Flex>
            </List.Header>
            {_topChannels.map((channel, index) => {
              return (
                <List.Item borderColor="#d6d6d6 !important" key={index}>
                  <Flex alignItems="center" justifyContent="space-between">
                    <Box width={1 / 3}>{channel.ssid}</Box>
                    <Box width={1 / 3}>{channel.networkCallSign}</Box>
                    <Box width={1 / 3}>{channel.sambaCallSign}</Box>
                  </Flex>
                </List.Item>
              );
            })}
          </Box>
        )}
      </Modal.Content>
      <Modal.Actions justifyContent="flex-end" borderColor="#d6d6d6 !important">
        <Flex>
          <Box mr={3}>
            <Button variant="secondary" onClick={onClose}>
              Cancel
            </Button>
          </Box>
        </Flex>
      </Modal.Actions>
    </Modal>
  );
};

TopChannelsModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
};

export default TopChannelsModal;
